import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

export const Footer = () => (
    <footer className="relative border-t border-white/10 bg-[#050507]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                <div className="md:col-span-6">
                    <div className="flex items-center gap-4">
                        <LogoMark className="w-10 h-10 text-white" />
                        <div>
                            <span className="font-display font-bold tracking-[0.18em] text-white text-lg block">
                                WRLDKIND
                            </span>
                            <span className="font-mono-meta text-[9px] tracking-[0.5em] text-slate-500 block mt-1">
                                STUDIOS
                            </span>
                        </div>
                    </div>
                    <p className="mt-6 font-serif-accent italic text-xl text-slate-300">
                        Worlds Worth Belonging To.
                    </p>
                    <p className="mt-4 max-w-sm text-sm text-slate-500 leading-relaxed">
                        An independent studio building persistent social online worlds.
                        Currently in early development on our first title.
                    </p>
                </div>

                <div className="md:col-span-3">
                    <h3 className="font-mono-meta text-[10px] tracking-[0.35em] uppercase text-slate-500">
                        Follow
                    </h3>
                    <ul className="mt-5 space-y-3">
                        <li>
                            <a
                                data-testid="footer-x-link"
                                href="https://x.com/WRLDKINDStudios"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-sm text-slate-300 hover:text-[#A855F7] transition-colors"
                            >
                                X / Twitter
                            </a>
                        </li>
                        <li>
                            <Link
                                data-testid="footer-kickstarter-link"
                                to="/kickstarter"
                                className="text-sm text-slate-300 hover:text-[#A855F7] transition-colors"
                            >
                                Kickstarter
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="md:col-span-3">
                    <h3 className="font-mono-meta text-[10px] tracking-[0.35em] uppercase text-slate-500">
                        Contact
                    </h3>
                    <a
                        data-testid="footer-email-link"
                        href="mailto:wrldkindstudios@gmail.com"
                        className="mt-5 inline-block text-sm text-slate-300 hover:text-[#A855F7] transition-colors"
                    >
                        wrldkindstudios@gmail.com
                    </a>
                </div>
            </div>

            <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <p className="font-mono-meta text-[10px] tracking-[0.25em] uppercase text-slate-600">
                    © 2026 WRLDKIND Studios — All rights reserved
                </p>
                <p className="font-mono-meta text-[10px] tracking-[0.25em] uppercase text-slate-600">
                    All imagery is representative concept photography
                </p>
            </div>
        </div>
    </footer>
);
